import routes from './routes'

export const slug = 'contactless-delivery'
export { routes }
